<template>
    <div class="text-[#1E293B] min-h-screen p-6 sm:p-10 font-inter">
      <main class="max-w-4xl mx-auto">
        <h1 class="text-2xl font-semibold mb-1">Vos Réservations</h1>
        <p class="text-sm text-[#475569] mb-6">Voir vos événements programmés</p>
  
        <nav
          id="filterTabs"
          class="inline-flex rounded-md mb-6"
          role="tablist"
          aria-label="Catégories de réservations"
        >
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            :class="[
              'px-4 py-2 text-sm border border-[#E2E8F0]',
              index === 0 ? 'rounded-l-md border-r-0' : '',
              index === tabs.length - 1 ? 'rounded-r-md border-l-0' : '',
              activeTab === tab.value
                ? 'text-[#1E293B] font-medium bg-white shadow-[0_1px_2px_rgb(0_0_0_/_0.05)]'
                : 'text-[#64748B] hover:text-[#475569] font-normal bg-[#F1F5F9]',
            ]"
            role="tab"
            :tabindex="activeTab === tab.value ? 0 : -1"
            @click="activeTab = tab.value"
          >
            {{ tab.label }}
          </button>
        </nav>
  
        <section class="space-y-3" id="bookingsList">
<article
  v-for="booking in filteredBookings"
  :key="booking._id"
  :data-status="booking.statut"
  :class="[
    'flex flex-col sm:flex-row sm:items-center justify-between rounded-lg border border-[#E2E8F0] p-4 relative',
    booking.active ? 'bg-[#F1F5F9]' : 'bg-white',
  ]"
>
            <div class="flex flex-col items-center min-w-[80px] pr-4 border-r border-[#E2E8F0] space-y-1">
              <div
                class="font-semibold text-sm leading-none select-none"
                :class="booking.active ? 'text-[#475569]' : 'text-[#DC4C00]'"
              >
                {{ booking.monthShort }}
              </div>
              <div
                class="font-extrabold text-3xl leading-none select-none"
                :class="booking.active ? 'text-[#475569]' : 'text-[#DC4C00]'"
              >
                {{ booking.day }}
              </div>
            </div>
  
            <div class="flex-1 flex flex-col sm:flex-row sm:items-center sm:space-x-6 text-sm text-[#475569] ml-4">
              <div class="flex flex-col space-y-1 mb-3 sm:mb-0 sm:min-w-[130px]">
                <div class="flex items-center space-x-2">
                  <i class="far fa-clock text-xs"></i>
                  <span>{{ booking.timeRange }}</span>
                </div>
                <div class="flex items-center space-x-2">
                  <i class="fas fa-map-marker-alt text-xs"></i>
                  <span>{{ booking.firm.nom_societe }}</span>
                </div>
              </div>
             <!-- S'il y a au moins un service -->
<div v-if="booking.statut == 'annulé'" class="text-sm text-[#1E293B] font-medium truncate max-w-xs">
    {{ booking.statut }} : {{ booking.motif_annulation }}
</div>

<!-- S'il n'y a aucun service -->
<div v-else class="text-sm text-[#1E293B] font-medium truncate max-w-xs">
  {{ booking.services[0].nom }}
</div>

            </div>
  
<button
  type="button"
  class="text-xs flex items-center space-x-1 ml-auto sm:ml-6"
  :class="booking.active
    ? 'text-white bg-[#0F172A] rounded px-4 py-2'
    : 'text-[#475569] bg-[#F9FAFB] border border-[#E2E8F0] rounded px-3 py-1 hover:bg-[#E2E8F0] transition'"
  @click="toggleMenu(booking._id)"
>
  <span>Modifier</span>
  <i :class="['fas', booking.active ? 'fa-chevron-up' : 'fa-chevron-down', 'text-[8px]']"></i>
</button>
  
<div
  v-if="activeMenu === booking._id"
  class="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg border border-[#E2E8F0] shadow-lg z-10"
  :id="'menu-' + booking._id"
  role="menu"
>
              <button
                class="flex items-center space-x-2 px-4 py-2 text-sm text-[#475569] hover:bg-[#F1F5F9] w-full text-left"
                @click="openReplanifyModal(booking)"
              >
                <i class="far fa-calendar-alt text-xs"></i>
                <span>Replanifier le rendez-vous</span>
              </button>
              <button
  v-if="!booking.terminer && !booking.avisDejaLaisse"
  @click="openReviewModal(booking)"
  class="flex items-center space-x-2 px-4 py-2 text-sm text-[#475569] hover:bg-[#F1F5F9] w-full text-left"
>
   <i class="far fa-star text-xs"></i>
                <span>Laissez un avis</span>
</button>
              <button
  class="flex items-center space-x-2 px-4 py-2 text-sm text-[#DC2626] hover:bg-[#FEE2E2] w-full text-left"
  @click="openCancelDialog(booking._id)"
>
  <i class="fas fa-times text-xs"></i>
  <span>Annuler le rendez-vous</span>
</button>

            </div>
          </article>
        </section>
      </main>
  
      <!-- Modal Annulation -->
      <div v-if="showCancelModal" class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-lg w-full max-w-md">
          <h2 class="text-lg font-semibold mb-4">Annuler le rendez-vous</h2>
          <textarea v-model="cancelReason" rows="4" placeholder="Motif de l'annulation" class="w-full p-2 border rounded mb-4"></textarea>
          <div class="flex justify-end space-x-2">
            <button class="px-4 py-2 bg-gray-200 rounded" @click="showCancelModal = false">Fermer</button>
            <button class="px-4 py-2 bg-red-600 text-white rounded" @click="confirmCancellation">Confirmer</button>
          </div>
        </div>
      </div>
  

<!-- Modal d'annulation -->
<div v-if="isCancelDialogOpen" class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
  <div class="bg-white p-6 rounded-lg w-full max-w-md">
    <h2 class="text-lg font-semibold mb-4">Annuler ce rendez-vous</h2>

    <label class="block text-sm font-medium mb-1">Motif d'annulation <span class="text-red-500">*</span></label>
    <select
      v-model="cancelReason"
      class="w-full border rounded px-3 py-2 text-sm mb-4"
    >
      <option disabled value="">-- Sélectionnez un motif --</option>
      <option value="Changement d’avis">Changement d’avis</option>
      <option value="Problème de disponibilité">Problème de disponibilité</option>
      <option value="Erreur de réservation">Erreur de réservation</option>
      <option value="Service non conforme à mes attentes">Service non conforme à mes attentes</option>
    </select>

    <div class="flex justify-end gap-2">
      <button @click="isCancelDialogOpen = false" class="px-4 py-2 bg-gray-200 rounded">Retour</button>
      <button
        @click="submitCancellation"
        :disabled="!cancelReason"
        class="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50"
      >
        Confirmer
      </button>
    </div>
  </div>
</div>


<!-- Modal Laisser un Avis -->
<div v-if="showReviewModal" class="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
  <div class="bg-white p-6 rounded-lg w-full max-w-md">
    <h2 class="text-lg font-semibold mb-4">Laisser un avis</h2>

    <textarea
      v-model="reviewForm.avis"
      rows="4"
      placeholder="Écrivez votre avis ici..."
      class="w-full border p-2 rounded mb-4"
    ></textarea>

<!-- Note de l’établissement -->
<label class="block text-sm mb-1">Note de l’établissement</label>
<div class="flex items-center mb-4 space-x-1">
  <template v-for="i in 5" :key="'etab' + i">
    <svg
      @click="reviewForm.note_etablissement = i"
      :class="i <= reviewForm.note_etablissement ? 'text-yellow-400' : 'text-gray-300'"
      class="w-6 h-6 cursor-pointer transition-colors"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.285 3.955a1 1 0 00.95.69h4.163c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.285 3.955c.3.921-.755 1.688-1.538 1.118L10 13.347l-3.37 2.448c-.783.57-1.838-.197-1.538-1.118l1.285-3.955a1 1 0 00-.364-1.118L2.643 9.382c-.783-.57-.38-1.81.588-1.81h4.163a1 1 0 00.95-.69l1.285-3.955z" />
  </svg>
</template>

    </div>

<!-- Note des prestations -->
<label class="block text-sm mb-1">Note des prestations</label>
<div class="flex items-center mb-4 space-x-1">
  <template v-for="i in 5" :key="'presta' + i">
    <svg
      @click="reviewForm.note_prestations = i"
      :class="i <= reviewForm.note_prestations ? 'text-yellow-400' : 'text-gray-300'"
      class="w-6 h-6 cursor-pointer transition-colors"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.285 3.955a1 1 0 00.95.69h4.163c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.285 3.955c.3.921-.755 1.688-1.538 1.118L10 13.347l-3.37 2.448c-.783.57-1.838-.197-1.538-1.118l1.285-3.955a1 1 0 00-.364-1.118L2.643 9.382c-.783-.57-.38-1.81.588-1.81h4.163a1 1 0 00.95-.69l1.285-3.955z" />
  </svg>
</template>

    </div>

<!-- Note de l’employé -->
<label class="block text-sm mb-1">Note de l’employé</label>
<div class="flex items-center mb-4 space-x-1">
  <template v-for="i in 5" :key="'emp' + i">
    <svg
      @click="reviewForm.note_employe = i"
      :class="i <= reviewForm.note_employe ? 'text-yellow-400' : 'text-gray-300'"
      class="w-6 h-6 cursor-pointer transition-colors"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.285 3.955a1 1 0 00.95.69h4.163c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.285 3.955c.3.921-.755 1.688-1.538 1.118L10 13.347l-3.37 2.448c-.783.57-1.838-.197-1.538-1.118l1.285-3.955a1 1 0 00-.364-1.118L2.643 9.382c-.783-.57-.38-1.81.588-1.81h4.163a1 1 0 00.95-.69l1.285-3.955z" />
  </svg>
</template>

    </div>

    <div class="flex justify-end gap-2 mt-4">
      <button @click="showReviewModal = false" class="px-4 py-2 bg-gray-200 rounded">Annuler</button>
      <button
        @click="submitReview"
        :disabled="!isReviewValid"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        Envoyer
      </button>
    </div>
  </div>
</div>




    </div>
  </template>
  
<script>
import axios from 'axios'
export default {
  name: 'BookingTabs',

  data() {
    return {
      showReviewModal: false,
       reviewForm: {
  avis: '',
  note_etablissement: 0,
  note_prestations: 0,
  note_employe: 0,
},

      tabs: [
        { label: 'À venir', value: 'confirmé' },
        { label: 'Passées', value: 'terminer' },
        { label: 'Annulées', value: 'annulé' },
      ],
      activeTab: 'confirmé',
          motifAnnulation: '',
      bookings: [],
      showCancelModal: false,
    isCancelDialogOpen: false,
      showAnnulModal : false,
      showModifyModal: false,
      selectedServices : [],
       selectedBookingIndex: null,
      selectedBooking: null,
      showConfirmDeleteService: false,
      indexServiceToDelete: null,
      showReplanifyModal: false,
      cancelReason: '',
      serviceToDeleteId: null,
       activeMenu: null,
       selectedAppointmentId: null,
    }
  },

  computed: {
    filteredBookings() {
      return this.bookings.filter(b => b.statut === this.activeTab)
    },
     isReviewValid() {
    return (
      this.reviewForm.avis.length > 5 &&
      this.reviewForm.note_etablissement > 0 &&
      this.reviewForm.note_prestations > 0 &&
      this.reviewForm.note_employe > 0
    );
  }
  },

  methods: {
async submitReview() {
  try {
    const token = localStorage.getItem('clientToken');
    const response = await fetch('https://b53c7d5edf32.ngrok-free.app/api/avis', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        ...this.reviewForm,
        employeId: this.selectedBooking.employe._id,
        firmId: this.selectedBooking.firm._id,
        appointmentId: this.selectedBooking._id
      })
    });

    if (response.ok) {
      // Tout s'est bien passé
      this.showReviewModal = false;
      this.selectedBooking.avisDejaLaisse = true;
      alert('Merci pour votre avis !');
    } else {
      // Ici, la requête a échoué, on récupère le message d'erreur
      const data = await response.json();

      if (response.status === 400 && data.message === 'Avis déjà passé') {
        // Cas spécifique : avis déjà laissé, mais on veut remercier
        this.showReviewModal = false;
        this.selectedBooking.avisDejaLaisse = true;
        alert('Merci pour votre avis !');
      } else {
        // Autres erreurs
        alert(`Erreur : ${data.message || 'Impossible d\'envoyer votre avis.'}`);
      }
    }
  } catch (error) {  if (error.response && error.response.status === 401) {
      // Supprime le token et redirige vers la page de connexion
      localStorage.removeItem('adminToken');
      this.$router.push('/login'); // ou '/login' selon ta route
    }
    console.error('Erreur lors de l\'envoi de l\'avis :', error);
    alert('Erreur lors de l\'envoi de l\'avis.');
  }
},


    openReviewModal(booking) {
    this.selectedBooking = booking;
    this.showReviewModal = true;
    this.reviewForm = {
      avis: '',
      note_etablissement: null,
      note_prestations: null,
      note_employe: null,
    };
  },
    openCancelDialog(id) {
    this.selectedAppointmentId = id;
    this.cancelReason = '';
    this.isCancelDialogOpen = true;
  },
  async submitCancellation() {
    if (!this.cancelReason || !this.selectedAppointmentId) return;

    try {
      const token = localStorage.getItem('clientToken');

      const response = await fetch(`https://b53c7d5edf32.ngrok-free.app/api/appointment/annuler/${this.selectedAppointmentId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ motif: this.cancelReason })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Erreur inconnue');
      }

      alert('✅ Rendez-vous annulé avec succès');
      this.isCancelDialogOpen = false;
      this.fetchBookings()

    } catch (error) {  if (error.response && error.response.status === 401) {
      // Supprime le token et redirige vers la page de connexion
      localStorage.removeItem('adminToken');
      this.$router.push('/login'); // ou '/login' selon ta route
    }
      console.error('Erreur d\'annulation :', error);
      alert('❌ Échec de l\'annulation : ' + error.message);
    }
  },
  toggleMenu(bookingId) {
    this.activeMenu = this.activeMenu === bookingId ? null : bookingId;
  },

openCancelModal(bookingId) {
    const booking = this.filteredBookings.find(b => b._id === bookingId);
    if (booking) {
      this.selectedBooking = booking;
      this.showCancelModal = true;
    }
  },

    openModifyModal(bookingId) {
    const booking = this.filteredBookings.find(b => b._id === bookingId);
    if (booking) {
      this.selectedBooking = booking;
      this.showModifyModal = true;
    }
  },
    closeModifyModal() {
      this.showModifyModal = false
      this.selectedBooking = null
      this.selectedBookingIndex = null
    },

confirmDeleteService(serviceId) {
  this.serviceToDeleteId = serviceId;
  this.showConfirmDeleteService = true;
},

    cancelDeleteService() {
      this.showConfirmDeleteService = false
      this.indexServiceToDelete = null
    },

async deleteService() {
  try {
    const services = this.selectedBooking.services;

    const serviceToDelete = services.find(s => s._id === this.serviceToDeleteId);
    if (!serviceToDelete) {
      console.warn("Service à supprimer introuvable avec l'ID :", this.serviceToDeleteId);
      return;
    }

    const payload = {
      servicesASupprimer: [this.serviceToDeleteId],
    };

    if (services.length === 1) {
      if (!this.motifAnnulation || this.motifAnnulation.trim() === "") {
        alert("Veuillez sélectionner un motif d'annulation.");
        return;
      }
      payload.motif = this.motifAnnulation;
    }

    const response = await axios.put(
      `https://b53c7d5edf32.ngrok-free.app/api/appointment/supprimer-prestations/${this.selectedBooking._id}`,
      payload,
      { headers: { Authorization: `Bearer ${localStorage.getItem("clientToken")}` } }
    );

    this.selectedBooking = response.data.rendezVous;
    this.showConfirmDeleteService = false;
    this.motifAnnulation = '';
    this.serviceToDeleteId = null;
  } catch (error) {  if (error.response && error.response.status === 401) {
      // Supprime le token et redirige vers la page de connexion
      localStorage.removeItem('adminToken');
      this.$router.push('/login'); // ou '/login' selon ta route
    }
    console.error("Erreur suppression service :", error);
  }
}
,


    async saveModifications() {
      try {
        // Ici tu envoies les modifications (services modifiés) au backend
        const token = localStorage.getItem('clientToken')

        const updatedServices = this.selectedBooking.services.map(s => s._id)

        await axios.put(`https://b53c7d5edf32.ngrok-free.app/api/appointment/${this.selectedBooking._id}`, {
          services: updatedServices,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        })

        // Mets à jour la liste locale
        this.bookings[this.selectedBookingIndex].services = [...this.selectedBooking.services]

        this.closeModifyModal()
        alert('Modifications sauvegardées')
      } catch (err) {
        console.error('Erreur lors de la sauvegarde :', err)
        alert('Erreur lors de la sauvegarde')
      }
    },

    async cancelAppointment(appointmentId) {
      try {
        const token = localStorage.getItem('clientToken')
        await axios.delete(`https://b53c7d5edf32.ngrok-free.app/api/appointment/${appointmentId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        alert('Rendez-vous annulé.')
        this.fetchBookings()
      } catch (err) {
        console.error('Erreur annulation rendez-vous :', err)
        alert('Erreur lors de l\'annulation')
      }
    },

openReplanifyModal(booking) {
  const serviceIds = booking.services.map(service => service._id);

  const firmId = booking.firm._id;

  this.$router.push({
    path: `/rendez-vous/${firmId}`,
    query: {
      replanifier: true,
      bookingId: booking._id,
      service: serviceIds.join(',') // Note: c’est "service" ici, pas "replanifier"
    }
  });
},


    confirmCancellation() {
      alert(`Rendez-vous annulé pour la raison : ${this.cancelReason}`)
      this.showCancelModal = false
      this.cancelReason = ''
    },

   async fetchBookings() {
  try {
    const token = localStorage.getItem('clientToken')
    if (!token) throw new Error('Token client manquant')

    const res = await axios.get('https://b53c7d5edf32.ngrok-free.app/api/appointment/mes-rendez-vous', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

          console.log(res.data)


    this.bookings = res.data.rendezVous.map(rdv => {
      const dateObj = new Date(rdv.date_rdv)
      const startHour = dateObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
      const endDateObj = new Date(dateObj.getTime() + rdv.duree_minutes * 60000)
      const endHour = endDateObj.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })

      // Format de l'heure complète : 07h00 - 09h00
      const timeRange = `${startHour} - ${endHour}`

      // Format du jour (ex: 30)
      const day = dateObj.getDate()

      // Mois abrégé en majuscule (ex: JUI pour juin)
      const monthShort = dateObj.toLocaleDateString('fr-FR', { month: 'short' }).toUpperCase()

      return {
        ...rdv,
        active: false,
        timeRange,
        day,
        monthShort,
      }
    })
  } catch (err) {
    console.error('Erreur récupération rendez-vous client :', err)
  }
},

    formatTimeRange(startDate, durationMinutes) {
      const start = new Date(startDate)
      const end = new Date(start.getTime() + durationMinutes * 60000)

      const format = (date) =>
        date.toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
        })

      return `${format(start)} - ${format(end)}`
    },
  },

  mounted() {
    this.fetchBookings()
  }
}
</script>

  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
  
  .font-inter {
    font-family: 'Inter', sans-serif;
  }
  
  .scrollbar-thin::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .scrollbar-thin::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 3px;
  }
  </style>
  